import { render } from "./CodeGenerator.vue?vue&type=template&id=5896dcba"
import script from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Inventory/CodeGenerator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5896dcba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5896dcba', __exports__)) {
    api.reload('5896dcba', __exports__)
  }
  
  module.hot.accept("./CodeGenerator.vue?vue&type=template&id=5896dcba", () => {
    api.rerender('5896dcba', render)
  })

}


export default __exports__